import * as React from 'react';
import { createContext, useContextSelector } from '@fluentui/react-context-selector';
import { useBoolean } from '@fluentui/react-hooks';
const Context = createContext({});
const Provider = Context.Provider;
export const useProgressionScorecardContext = (selector) => useContextSelector(Context, selector);
export const ProgressionScorecardProvider = ({ featureId, children }) => {
    const [selectedAnalysisGroupId, setSelectedAnalysisGroupId] = React.useState('');
    const [selectedAnalysisTemplateId, setSelectedAnalysisTemplateId] = React.useState('');
    const [isPanelOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);
    const [isValidationErrorOpen, { setTrue: openErrorPanel, setFalse: dismissErrorPanel }] = useBoolean(false);
    const openPanelWithSelection = React.useCallback((analysisGroupId = '') => {
        setSelectedAnalysisGroupId(analysisGroupId);
        openPanel();
    }, [openPanel, setSelectedAnalysisGroupId]);
    const clearAndDismissPanel = React.useCallback(() => {
        setSelectedAnalysisGroupId('');
        dismissPanel();
    }, [dismissPanel, setSelectedAnalysisGroupId]);
    const openErrorPanelWithSelection = React.useCallback((analysisGroupId, analysisTemplateId) => {
        setSelectedAnalysisGroupId(analysisGroupId);
        setSelectedAnalysisTemplateId(analysisTemplateId);
        openErrorPanel();
    }, [openErrorPanel, setSelectedAnalysisGroupId]);
    const clearAndDismissErrorPanel = React.useCallback(() => {
        setSelectedAnalysisGroupId('');
        setSelectedAnalysisTemplateId('');
        dismissErrorPanel();
    }, [dismissErrorPanel, setSelectedAnalysisGroupId]);
    return (React.createElement(Provider, { value: {
            featureId,
            isPanelOpen,
            isValidationErrorOpen,
            selectedAnalysisGroupId,
            selectedAnalysisTemplateId,
            setSelectedAnalysisGroupId,
            openPanel: openPanelWithSelection,
            dismissPanel: clearAndDismissPanel,
            openErrorPanel: openErrorPanelWithSelection,
            dismissErrorPanel: clearAndDismissErrorPanel,
        } }, children));
};

//# sourceMappingURL=Provider.js.map
